import { compact } from 'lodash';
import React from 'react';
import Video from 'src/assets/svg/order/video.svg';
import { AppButton } from 'src/shared/design-system/AppButtonDeprecated';
import { Loading } from 'src/shared/design-system/Loading';
import { lazyRetry } from 'src/util/retry';
import styled from 'styled-components';
import { Colors } from 'web-common/src/shared/styles';

const VideoModal = lazyRetry(() => import('src/shared/design-system/VideoModal'));
interface IProps {
  videoUrl?: string;
  imageUrl?: string;
  uploadedFiles?: any[];
  progress?: any;
  preprocessing?: boolean;
}

const VideoButton = styled(AppButton)`
  border-width: 0;
  outline: 0;
  font-size: 16px;
  color: ${Colors.ELDERBERRY_DARK_10};
  background-color: rgba(0, 170, 231, 0.22);
  border-radius: 30px;
  margin-bottom: 20px;
`;

export const DropzoneUploadDisplay: React.FC<IProps> = ({
  videoUrl,
  imageUrl,
  uploadedFiles,
  progress,
  preprocessing,
}: IProps) => {
  const [showVideo, setShowVideo] = React.useState<boolean>();

  const renderFileUpload = (uploadedFile: any, i: any) => {
    const {
      // filename,   // s3 filename
      fileUrl, // full s3 url of the file
      // file,       // file descriptor from the upload
    } = uploadedFile;

    return (
      <div key={i}>
        <img src={fileUrl} style={{ maxWidth: '100%', maxHeight: '100%' }} alt='Upload Preview' />
      </div>
    );
  };

  const spinning = preprocessing || (progress !== null && progress !== undefined);

  return (
    <div>
      {spinning && <Loading />}
      {imageUrl ? (
        <div>
          <img src={imageUrl} style={{ maxWidth: '100%', maxHeight: '100%' }} alt='Upload Preview' />
        </div>
      ) : videoUrl ? (
        <>
          <VideoButton
            title='Video Bio'
            white
            onClick={(e) => {
              e.stopPropagation();
              setShowVideo(true);
            }}
            icon={<img style={{ marginBottom: 2 }} src={Video} alt='Play Video' />}
          />
          <VideoModal
            show={showVideo}
            url={videoUrl}
            title={`Playing: ${videoUrl}`}
            onHide={() => setShowVideo(false)}
          />
        </>
      ) : (
        compact(uploadedFiles).map(renderFileUpload)
      )}
    </div>
  );
};
